import { Component, Injectable } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({
  selector: 'manage-button',
  styleUrls: ['./manage-button.component.scss'],
  templateUrl: './manage-button.component.html',
})
@Injectable()
export class ManageButtonComponent implements AgRendererComponent {
  refresh(params: any): boolean {
    return undefined;
  }
  private params: any;

  agInit(params: any): void {
    this.params = params;
  }

  handleClick(e) {
    this.params.context.componentParent.emitAction('manage', this.params);
  }
}
